import { autoBeforeEachTest } from '@atlassian/jira-platform-auto-before-each-test/src/auto-before-each-test.tsx';
import { fg } from '@atlassian/jira-feature-gating';

let isPageHydrating = false;

// Even though this uses no hooks, we expose it as one to ensure it is only used during render
// (which is the only time we know if we're hydrating)
// For that reason, though, it's important that this never changes value
export function useIsPageHydrating(): boolean {
	if (!fg('jfp-magma-use-is-page-hydrating-hook')) {
		return false;
	}
	return isPageHydrating;
}

export function setPageHydrating(): void {
	isPageHydrating = true;
}

autoBeforeEachTest(() => {
	isPageHydrating = false;
});
